import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

// These methods are similar, but not identical to those found in cn-web-utils/api
// These methods are marketplace specific, and are designed to work with run time config/Next.js

export function getHeaders(version) {
  return {
    Accept: `application/json version=${version};`,
    'Content-Type': 'application/json; charset=UTF-8',
    'X-CN-App-Info': `Marketplace-Web/${publicRuntimeConfig.appVersion}`,
  };
}

export function getFinalParams({ channel, params }) {
  return {
    ...params,
    meta: {
      marketplace: {
        id: '2',
        x_id: null,
      },
      channel,
    },
  };
}

// Formatting function that returns an object formatted for the Fetch API
export function apiRequest({ path, params = {}, method = 'GET' }) {
  const { apiHost } = publicRuntimeConfig;
  const endpoint = `${apiHost}/${path}`;
  const meta = params.meta || {};
  const headers = getHeaders('3.0');
  // Short circuit any GET requests regardless of domain
  if (method.toUpperCase() === 'GET') {
    return {
      credentials: 'include',
      method,
      headers,
      endpoint,
    };
  }
  const { channel } = meta;
  const finalParams = getFinalParams({ channel, params });
  return {
    credentials: 'include',
    method,
    headers,
    endpoint,
    body: JSON.stringify(finalParams),
  };
}

// Method for making GET requests to chownow API.
// Properly formats requests for different domains.
export async function getFromChownowApi(endpoint) {
  const { endpoint: formattedEndpoint, ...options } = apiRequest({ path: endpoint });
  let data;
  let error;
  try {
    const response = await fetch(formattedEndpoint, options);
    if (response.status === 404) {
      error = { message: 'Error fetching resource' };
      return { data, error };
    }
    data = await response.json();
  } catch (e) {
    error = e;
  }

  return { data, error };
}

// Method for making POST requests to chownow API.
// Properly formats requests for different domains.
export async function postToChownowApi(endpoint, body) {
  const { endpoint: formattedEndpoint, ...options } = apiRequest({
    path: endpoint,
    params: body,
    method: 'POST',
  });

  try {
    const response = await fetch(formattedEndpoint, options);
    const { status } = response;
    const data = await response.json();
    switch (status) {
      case 404:
        return {
          data: null,
          error: {
            message: 'Error fetching resource',
          },
        };
      case 400:
        // 400 responses do not cause fetch to throw
        // in this case the "data" should be reassigned as an error
        return {
          error: data,
          data: null,
        };
      default:
        return {
          error: null,
          data,
        };
    }
  } catch (e) {
    return { data: null, error: e };
  }
}
